export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/options-switch/OptionsSwitch.tsx"